import httpClient from './http.client'
// import SiteMember from "@/store/modules/siteMember"

class GeneralService {

  contactUs(payload) {
    return httpClient.post(`v1/contact-us`, payload).then((res) => res.data);
  }

  getMapsApiKey() {
    return httpClient.get(`v1/maps-api-key`).then((res) => res.data);
  }
}
export let generalService = new GeneralService();